<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2017 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2017</p>
<p class="crt">Paperback edition 2018</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">27 26 25 24 23 22 21 20 19 18    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-37596-0 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-41809-4 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-37601-1 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226376011.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226376011.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Steinbeck, Paul, author.</p>
<p class="cip">Title: Message to our folks : the Art Ensemble of Chicago / Paul Steinbeck.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2017. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2016028219| ISBN 9780226375960 (cloth : alk. paper) | ISBN 9780226376011 (e-book)</p>
<p class="cip">Subjects: LCSH: Art Ensemble of Chicago—History. | Jazz—Illinois—Chicago—History and criticism. | African Americans—Illinois—Chicago—Music—History and criticism.</p>
<p class="cip">Classification: LCC ML28.C4 A774 2017 | DDC 784.4/165—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2016028219" target="_blank">https://lccn.loc.gov/2016028219</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48–1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Steinbeck-update-0004.vue?08337647